export default {
  icp: '/admin/api/import/oil/icp',
  ir: '/admin/api/import/oil/ir',
  oe4: '/admin/api/import/oil/oe4',
  particleCount: '/admin/api/import/oil/particleCount',
  viscosity: '/admin/api/import/oil/viscosity'
};
